import { useQuery } from '@tanstack/react-query'
import { compareDesc, parseISO } from 'date-fns'
import { getHeaders } from 'services/api/utils'
import { getAdminUiUrlByPlatform } from 'utils/adminUi'
import { getPlatform } from 'utils/token/token'

const BASE_URL = getAdminUiUrlByPlatform(getPlatform())

const getReport = async (accountId, startDate, endDate, groupBy, campaigns, ads, statuses, page, perPage) => {
  let finalStartDate = startDate.toLocaleDateString('en-CA')
  if (compareDesc(parseISO(new Date('2024-09-01')), parseISO(startDate)) === -1) {
    finalStartDate = '2024-09-01'
  }
  const response = await fetch(
    `${BASE_URL}/api/AdInsightsReport/List`,
    getHeaders('POST', {
      ad_account_id: accountId,
      start_date: finalStartDate,
      end_date: endDate.toLocaleDateString('en-CA'),
      source: 'meta',
      group_by: groupBy,
      ad_ids: ads.join(),
      campaign_ids: campaigns.join(),
      statuses: statuses.join(),
      page,
      per_page: perPage,
    }),
  ).then((res) => res.json())
  return response
}

const useAdInsightsReport = ({ accountId, startDate, endDate, groupBy, campaigns, ads, statuses, page, perPage }) => {
  return useQuery({
    queryKey: ['ad-insights-report', accountId, startDate, endDate, groupBy, campaigns, ads, statuses, page, perPage],
    queryFn: () => getReport(accountId, startDate, endDate, groupBy, campaigns, ads, statuses, page, perPage),
    refetchOnMount: false,
    enabled: !!accountId,
    select: (data) => data[0],
  })
}

export default useAdInsightsReport
